import { VariantProps } from "cva";
import { ComponentProps } from "react";

import { cva } from "@/utils/cva.config";

type WrapperProps = ComponentProps<"div"> & VariantProps<typeof wrapperStyles>;
function Wrapper({ $background, className, children, ...props }: WrapperProps) {
  return (
    <div className={wrapperStyles({ className, $background })} {...props}>
      {children}
    </div>
  );
}

export const SideBySide = {
  Primary: (props: WrapperProps) => <Wrapper $background="gradiend" {...props} />,
  Secondary: (props: WrapperProps) => <Wrapper className="hidden flex-1/2 items-center justify-center bg-[#181d23] md:flex" {...props} />
};

const wrapperStyles = cva({
  base: ["flex flex-1/2 flex-col items-center justify-center bg-[#181d23] px-2 pt-4 pb-24 md:px-1 md:pb-0 2xl:pt-0 2xl:pb-0"],
  variants: {
    $background: {
      gradiend: "bg-linear-to-br from-[#003344] to-[#19222a]"
    }
  }
});
